import { Button, Center, Skeleton } from '@chakra-ui/react';
import { CellContext } from '@tanstack/react-table';

export type TOfferedServicesDataTableData = {
  primaryKey: number | string,
  id: string,
  label: string,
  [x: string]: string | number | boolean,
};

type Props = {
  isLoading: boolean | undefined,
  handleEdit: (row: any) => void,
};

export function getOfferedServicesDataTableColumns({ isLoading, handleEdit }: Props) {
  // console.table(meta.rowsFields);
  return [
    {
      accessorKey: 'id',
      id: 'id',
      header: 'Id',
      cell: (info: CellContext<any, any>) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>{info.getValue()}</Center>
          </Skeleton>
        );
      },
    },

    {
      accessorKey: 'label',
      id: 'label',
      header: () => 'Label',
      cell: (info: CellContext<any, any>) => {
        return <Skeleton isLoaded={!isLoading}>{info.getValue()}</Skeleton>;
      },
    },

    {
      id: 'action',
      header: '',
      cell: (info: CellContext<any, any>) => {
        return (
          <Skeleton isLoaded={!isLoading}>
            <Center>
              <Button
                size={'sm'}
                onClick={() => handleEdit(info.row)}
                mr={'1rem'}
              >
                Editer
              </Button>
            </Center>
          </Skeleton>
        );
      },
    },
  ];
}
